import React from 'react';
import { Link } from 'react-router-dom';

const base = 'inline-flex items-center justify-center font-semibold transition-all duration-200 rounded-full focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed';
const sizes = {
  sm: 'text-sm px-4 py-2',
  md: 'text-base px-6 py-2.5',
  lg: 'text-lg px-8 py-3',
};
const variants = {
  primary: 'bg-[#ff6b35] text-white rounded-full font-semibold shadow-none hover:bg-orange-600',
  secondary: 'bg-white text-orange-600 border border-orange-400 shadow hover:bg-orange-50',
  outline: 'bg-transparent border border-orange-500 text-orange-600 hover:bg-orange-50',
  ghost: 'bg-transparent text-orange-600 hover:bg-orange-50',
};

const renderIcon = (Icon) => {
  if (!Icon) return null;
  if (typeof Icon === 'function') return <Icon className="w-4 h-4" />;
  if (React.isValidElement(Icon)) return Icon;
  return null;
};

const Button = ({
  children,
  to,
  onClick,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  leftIcon: LeftIcon,
  rightIcon: RightIcon,
  className = '',
  type = 'button',
  disabled = false,
  ...rest
}) => {
  const classes = [
    base,
    sizes[size] || sizes.md,
    variants[variant] || variants.primary,
    fullWidth ? 'w-full' : '',
    className,
  ].join(' ');

  const content = (
    <>
      {LeftIcon && <span className="mr-2 flex items-center">{renderIcon(LeftIcon)}</span>}
      <span>{children}</span>
      {RightIcon && <span className="ml-2 flex items-center">{renderIcon(RightIcon)}</span>}
    </>
  );

  if (to) {
    return (
      <Link to={to} className={classes} onClick={onClick} {...rest}>
        {content}
      </Link>
    );
  }
  return (
    <button type={type} className={classes} onClick={onClick} disabled={disabled} {...rest}>
      {content}
    </button>
  );
};

export default Button; 